export const getIndicadoresCriterioSelecionado =
  (state) => state.indicadores.listaIndicadoresCriterioSelecionado
export const getIsCarregandoIndicadoresCriterioSelecionado =
  (state) => state.indicadores.isCarregandoListaIndicadoresCriterioSelecionado
